import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';
import BOLStyles from './__styles__/BOL.styles';
import { LOCATION_TYPE } from '../../constants/constants';
import MapIcon from '@material-ui/icons/MapOutlined';
import CalendarIcon from '@material-ui/icons/CalendarTodayTwoTone';
import TimeIcon from '@material-ui/icons/AccessTime';
import ArrowIcon from '@material-ui/icons/PlayArrow';
import { midnightSecondsToHour } from '../../utils/DateTime';
import { formatTime } from '../../utils/Shipment';

class Location extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    type: PropTypes.number.isRequired
  };

  render() {
    const { location, classes, t, type } = this.props;

    const borderClass =
      type === LOCATION_TYPE.PICKUP
        ? classes.originColor
        : classes.destinationColor;

    const bkgClass =
      type === LOCATION_TYPE.PICKUP
        ? classes.originBackground
        : classes.destinationBackground;

    const bkgTextClass =
      type === LOCATION_TYPE.PICKUP
        ? classes.originText
        : classes.destinationText;

    return (
      <Grid
        item
        xs={6}
        className={classnames(
          borderClass,
          bkgClass,
          classes.bolFont,
          classes.locationGridPadding
        )}
      >
        <span className={bkgTextClass}>
          <MapIcon fontSize="inherit" className={classes.textMargin} />
          {type === LOCATION_TYPE.PICKUP ? ' Pickup: ' : ' Delivery: '}
          <ArrowIcon fontSize="inherit" />
        </span>
        <CalendarIcon fontSize="inherit" className={classes.textMargin} />
        <span className={classes.textMargin}>
          {formatTime(location.plannedToTimeLocal)}
        </span>
        <TimeIcon fontSize="inherit" className={classes.margin10} />
        <span className={classes.textMargin}>{t('Dock Time')}: </span>
        {midnightSecondsToHour(location.openFromTimeLocal)}-
        {midnightSecondsToHour(location.openToTimeLocal)}
        <hr />
        <p className={classes.textMargin}>{location.locationName}</p>
        <p className={classes.textMargin}>
          {location.locationAddress.address1}
        </p>
        <p className={classes.textMargin}>
          {location.locationAddress.address2}
        </p>
        <p className={classes.textMargin}>
          {location.locationAddress.city}, {location.locationAddress.state}{' '}
          {location.locationAddress.postalCode}{' '}
          {location.locationAddress.country}
        </p>
        <p className={classes.textMargin}>{t('Contact Information')}: </p>
        <p className={classes.textMargin}>
          {location.contactInfo.firstName} {location.contactInfo.lastName}{' '}
        </p>
        <p className={classes.textMargin}>{location.contactInfo.phone}</p>
        <p className={classes.textMargin}>
          {t('Notes')}:{' '}
          {type === LOCATION_TYPE.ORIGIN
            ? location.pickupNotes
            : location.deliveryNotes}
        </p>
      </Grid>
    );
  }
}

const translatedLocation = withNamespaces()(Location);
export default withStyles(
  combineStyles(
    BOLStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedLocation);
